<template>
  <div class="dub-container" v-if="audio && audioObj">
    <div class="dub-item-container">
      <div class="wana-dub" @click="callUp">
        <img src="../../assets/share-dub-microphone.png" />
        <span>去配音</span>
      </div>
      <div class="dub-title">{{ audio.title }}</div>
      <div class="dub" :style="backgroundImage">
        <div class="dub-shadow"></div>
        <img v-if="!playing" class="dub-play-btn" src="../../assets/dub-play.png" @click="play"/>
        <img v-else class="dub-play-btn" src="../../assets/dub-pause.png" @click="pause"/>
      </div>
    </div>
    <div class="userInfo-container">
      <div class="userInfo-box">
        <div class="userInfo">
          <img class="userInfo-userImg" :src="audio.avatar_url"/>
          <div class="userInfo-info">
            <h3 class="userInfo-userNickname">{{ audio.user_nick }}</h3>
            <h3 class="userInfo-dubTime">{{ audio.create_time }}</h3>
          </div>
        </div>
        <div class="like">
          <div class="like-img" @click="like">
            <img :src="audio.is_like ? require('../../assets/share-dub-liked-icon.png') : require('../../assets/share-dub-like-icon.png')"/>
            <span class="like-count">{{ audio.like_count }}</span>
          </div>
        </div>
      </div>
    </div>
    <IvyFooter></IvyFooter>
  </div>
</template>

<script>
import store from '../../store'
import AudioPromise from '@ivy/fts/audioPromise'
import showBindPhone from '@ivy/fts/showBindPhone'
import openApp from '@ivy/fts/openApp'

export default {
  data() {
    return {
      audioObj: null,
      audio: null,
      currentTime: 0,
      playing: false
    }
  },
  computed: {
    backgroundImage() {
      return this.audio ? `background-image: url(${this.audio.pic_url});` : ''
    }
  },
  mounted() {
    this.audioObj = null
    this.initAudioObj()
  },
  methods: {
    callUp() {
      return openApp('readtool')
    },
    async initAudioObj() {
      let {data} = await this.$axios.get('/api/mobile/audios/dubbing/detail', {
        params: {
          id: this.$route.query.id,
        }
      })
      this.audio = data
      this.audioObj = await new AudioPromise(this.audio.dubbing_address, e => this.updateTime(e))
    },
    async updateTime(e) {
      if (Math.round(e.target.currentTime) - (+this.audio.audio_length) >= 0) {
        this.playing = false
        await this.audioObj.pause()
        return this.currentTime = 0
      }
      this.currentTime = e.target.currentTime
    },
    async play() {
      this.playing = true
      await this.audioObj.play(this.currentTime)
    },
    async pause() {
      this.playing = false
      await this.audioObj.pause()
    },
    async like() {
      if (this.audio.is_like === 1) return
      if (!store.logined.openid) {
        await store.login(this)
        return
      }
      let {data} = await this.$axios.get('/api/mobile/audios/dubbing/like', {
        params: {
          dubbing_id: this.$route.query.id,
          action: this.audio.is_like ? 'unlike' : 'like',
          token: store.logined.token
        }
      })
      if (data.message === 'ok') {
        this.audio.is_like = 1
        this.audio.like_count += 1
      }
    },
    async toRelation() {
      let { message, logined } = await showBindPhone() // 弹出绑定手机号的窗口
      // 绑定成功之后重新登录
      if (message === 'ok') {
        store.logined = logined
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="less">
@import (reference) url(../../project.less);

@keyframes wanaDubContainer
{
0% {left: -122px;}
100% {left: 0px;}
}
@keyframes wanaDubIcon
{
0% {transform:rotateZ(0deg);}
20% {transform:rotateZ(-22.5deg);}
40% {transform:rotateZ(22.5deg);}
60% {transform:rotateZ(-22.5deg);}
80% {transform:rotateZ(22.5deg);}
100% {transform:rotateZ(0deg);}
}
.dub-container {
  background:#f4f4f4;
}
.dub-item-container {
  background: #fff;
  padding-bottom: 110px;
  .wana-dub {
    position: absolute;
    animation:wanaDubContainer 1s;
    margin-top: 464px;
    background: @primary;
    border-radius:0 50.5px 50.5px 0;
    width:122px;
    height:74px;
    img {
      display: inline-block;
      transform-origin: 60% 60%;
      height: 52px;
      width: 52px;
      padding-left: 34px;
      padding-top: 12px;
      animation-timing-function: linear;
      animation:wanaDubIcon 1.5s 0.7s;
    }
    span {
      display: inline-block;
      position: relative;
      top: -15px;
      font-family:PingFangSC-Regular;
      font-size:22px;
      color:@primary;
      left: 20px;
    }
  }
  .dub-title {
    font-family:PingFangSC-Regular;
    font-size:36px;
    color:#333333;
    letter-spacing:0;
    text-align:center;
    padding-top: 80px;
  }
  .dub {
    margin: 42px auto 0;
    border-radius:30px;
    width:380px;
    height:380px;
    background-position-x: center;
    background-position-y: center;
    background-size: 380px 380px;
    .dub-shadow {
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.3;
      border-radius:30px;
    }
    .dub-play-btn {
      opacity:1;
      border:2px solid #fff;
      width:97px;
      height:97px;
      border-radius:100%;
      position: relative;
      left: 143px;
      bottom: 237px;
    }
  }
}
.userInfo-container {
  width:100vw;
  height:346px;
  background:#ffffff;
  margin-top: 2px;
  .userInfo-box {
    display: flex;
    justify-content: space-between;
    .userInfo {
      height: 81px;
      font-family:PingFangSC-Regular;
      display: flex;
      text-align: start;
      padding: 60px 0 0 30px;
      .userInfo-userImg {
        border:0 solid #e6e6e6;
        width:79.5px;
        height:79.5px;
        border-radius:100%;
      }
      .userInfo-info {
        height: 100%;
        padding: 3px 0 0 9px;
        .userInfo-userNickname {
          font-size:22px;
          color:#333333;
        }
        .userInfo-dubTime {
          font-size:20px;
          color:#999999;
        }
      }
    }
    .like {
      background: @primary;
      border-radius:100px;
      width:210px;
      height:80px;
      text-align:center;
      margin-top: 64px;
      margin-right: 30px;
      .like-img {
        padding-top: 19px;
        img {
          width:40px;
          height:42px;
        }
        .like-count {
          font-family:ArialMT;
          font-size:30px;
          color:#ffffff;
          padding-left: 22px;
          position: relative;
          bottom: 2px;
        }
      }
    }
  }
}
</style>
